export default __webpack_public_path__ + "static/media/sound1.cfa277c1.wav";